export default {"src":"/_next/static/media/wallet-polygon.f65a1631.svg","height":64,"width":64};